import Modal, { ModalProps } from "@/Components/Modal/Modal";
import { useModalMeta } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import { asArray } from "@/shared/utils/helpers";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import KioskLanguage from "./KioskLanguage";

export interface TableModalProps extends ModalProps {}

const KioskLanguages = ({ onExit, ...props }: TableModalProps) => {
  const [meta] = useModalMeta();
  const { i18n } = useTranslation();
  const t = useCommon();
  return (
    <Modal width={"95%"} onExit={onExit} {...props}>
      <div className="text-center text-[5rem]" style={{ fontWeight: "900" }}>
        {t("changeTheLanguage")}
      </div>
      <Row style={{ rowGap: "3rem" }}>
        {typeof i18n.options.supportedLngs !== "boolean" &&
          asArray([...i18n.options.supportedLngs])
            .filter((l) => l !== "cimode")
            .map((l) => (
              <Col key={l} xs={6}>
                <KioskLanguage l={l} />
              </Col>
            ))}
      </Row>
      {/* Additional content or options for language selection can be added here */}
    </Modal>
  );
};

export default KioskLanguages;
